import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";

function formatPhoneNumber(phoneNumber) {
	if (!phoneNumber) {
		return "";
	}

	const digits = phoneNumber.replace(/\D/g, "");
	if (digits.length === 9) {
		return `+27${digits}`;
	}

	if (digits.length === 11 && digits.startsWith("27")) {
		return `+${digits}`;
	}

	return phoneNumber;
}

export default function FlashPaymentAlertModal({ show, onClose, title, code, phoneNumber, message, isExisting, packageName }) {
	return (
		<Modal show={show} onHide={onClose} centered size="lg">
			<Modal.Header>
				<h3 className="mb-0 w-100 text-center">{title}</h3>
			</Modal.Header>
			<Modal.Body>
				{title === "Success" && (
					<div className="text-center">
						<FontAwesomeIcon icon={faCheckCircle} color="#009845" size="3x" />
						<p className="mt-3 mb-2">Your Flash payment code</p>
						<div className="font-weight-bold" style={{ fontSize: "2rem", letterSpacing: "0.2rem" }}>
							{code}
						</div>
						<p className="text-muted mb-0">
							{isExisting ? `Existing code reused for ${packageName}` : `New code created for ${packageName}`}
						</p>
						<p className="mt-3 mb-1">has been sent to</p>
						<p className="font-weight-bold mb-0">{formatPhoneNumber(phoneNumber)}</p>
						<p className="mt-3 mb-0">
							Take this code to a participating Flash retailer to complete your payment over the counter.
						</p>
					</div>
				)}
				{title === "Error" && (
					<div className="text-center">
						<FontAwesomeIcon icon={faTimesCircle} color="#FF0000" size="3x" />
						<p className="mt-3 mb-0">{message}</p>
					</div>
				)}
			</Modal.Body>
			<Modal.Footer>
				<GradientButton title="OK" variant="greenYellow" onClick={onClose} />
			</Modal.Footer>
		</Modal>
	);
}
